var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "py-4 flex", attrs: { id: `question_${_vm.index + 1}` } },
    [
      _c(
        "span",
        {
          staticClass:
            "w-20 py-5 px-6 text-3xl leading-relaxed absolute transform -translate-y-3 lg:translate-y-0",
          class: { [_vm.correctClass]: _vm.examTypeQuiz },
        },
        [_vm._v(_vm._s(_vm.index + 1))]
      ),
      _c(
        "div",
        {
          class: [
            "min-w-0 py-3 flex-1 lg:pl-20 lg:py-5",
            [_vm.isMobile ? "pl-20" : "pl-14"],
          ],
        },
        [
          [
            _c(
              "div",
              { staticClass: "-ml-20 pl-20 flex items-start gap-x-1" },
              [
                _c(
                  "p",
                  { staticClass: "w-full rounded-lg py-2.5 px-5 bg-gray-100" },
                  [_vm._v(_vm._s(_vm.question.questionTitle))]
                ),
                _vm.examTypeQuiz
                  ? _c(
                      "div",
                      { staticClass: "flex items-center gap-x-0.5" },
                      [
                        _c("GrmTextField", {
                          staticClass: "w-20",
                          attrs: {
                            type: "number",
                            value: _vm.question.questionScore,
                            disabled: "",
                          },
                        }),
                        _c("span", { staticClass: "text-xs" }, [
                          _vm._v(_vm._s(_vm.$t("exam.question.point"))),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            ),
          ],
          _c(
            "div",
            { staticClass: "mt-2 flex flex-col gap-y-1 relative" },
            _vm._l(_vm.questionAnswerListWithUserAnswer, function (answer, i) {
              return _c(
                "div",
                {
                  key: answer.answerId,
                  staticClass: "flex items-center gap-x-1",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "question min-w-0 max-w-max flex-1 rounded py-1 flex gap-x-2 items-baseline",
                    },
                    [
                      _vm.question.questionType === "CHOICE"
                        ? _c("div", { staticClass: "relative" }, [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "number w-5 h-5 border rounded-full flex justify-center items-center text-sm select-none transition pointer-events-none",
                                class: [
                                  answer.userAnswer?.answerId
                                    ? "border-blue-400 bg-blue-400 text-white"
                                    : "border-gray-800",
                                ],
                              },
                              [_vm._v(_vm._s(i + 1))]
                            ),
                            answer.correct
                              ? _c("span", {
                                  staticClass:
                                    "w-5 h-5 bg-exam-check-red block absolute -top-2.5 -left-0.5 pointer-events-none",
                                })
                              : _vm._e(),
                          ])
                        : _vm._e(),
                      _c(
                        "p",
                        {
                          staticClass:
                            "min-w-0 max-w-max flex-1 rounded-lg py-2 px-3 bg-gray-100 text-xs",
                        },
                        [_vm._v(_vm._s(answer.answerTitle))]
                      ),
                    ]
                  ),
                ]
              )
            }),
            0
          ),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }